<div class="login-container">
  <!-- Left Side - Image -->
  <div class="login-image">
    <div class="floating-elements">
      <div class="floating-element"></div>
      <div class="floating-element"></div>
      <div class="floating-element"></div>
    </div>

    <div class="image-content">
      <div class="brand-logo">
        <a routerLink="/">
          <img
            src="https://insizon-email-templates-bucket.s3.us-east-2.amazonaws.com/insizon/insizon-logo-v2-png.png"
            alt="Insizon Logo"
            class="logo-image" />
        </a>
      </div>
      <h3 class="welcome-text">Welcome Back!</h3>
      <div class="welcome-subtitle">
        We build innovative software solutions that solve real-world problems
        and drive business transformation.
      </div>
    </div>
  </div>

  <!-- Right Side - Form -->
  <div class="login-form">
    <div class="form-container">
      <div class="form-header">
        <h2 class="form-title">Reset Password</h2>
        <p class="form-subtitle">
          Enter new credentials to access your account
        </p>
      </div>

      <!-- Error message -->
      <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
        <p>
          <i class="bi bi-exclamation-triangle me-2"></i>
          {{ errorMessage }}
        </p>
        <button type="button" class="btn-close" (click)="clearError()"></button>
      </div>

      <!-- Form starts -->
      <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
        <div class="form-group mb-2">
          <label for="password">
            <i class="fa-solid fa-lock me-2"></i>Password
          </label>
          <div class="password-wrap">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              name="password"
              placeholder="Enter your password"
              class="form-control"
              [(ngModel)]="resetPasswordModel.newPassword"
              required
              [disabled]="isLoading"
              #password="ngModel" />
            <button
              type="button"
              class="toggle-password"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="
                showPassword ? 'Hide password' : 'Show password'
              ">
              <i
                [ngClass]="
                  showPassword ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'
                "></i>
            </button>
          </div>
          <div
            *ngIf="password.invalid && (password.dirty || password.touched)"
            class="error-message">
            <small *ngIf="password.errors?.['required']"
              >Password is required.</small
            >
          </div>
        </div>

        <div class="form-options float-end">
          <button
            type="button"
            class="forgot-password-link"
            (click)="navigateToForgotPassword()"
            [disabled]="isLoading">
            Login?
          </button>
        </div>

        <button
          type="submit"
          class="login-btn"
          [disabled]="loginForm.invalid || isLoading">
          <span *ngIf="!isLoading"> Reset Password </span>
          <span *ngIf="isLoading">
            <i class="bi bi-arrow-repeat spin me-2"></i>Reseting Password...
          </span>
        </button>
      </form>

      <div class="divider">
        <span>Or continue with</span>
      </div>
      <div class="signup-link">
        Don't have an account?
        <button
          type="button"
          class="register-link"
          (click)="navigateToRegister()"
          [disabled]="isLoading">
          Sign up
        </button>
      </div>
    </div>
  </div>
</div>
